import { Component, Input } from '@angular/core';

@Component({
    selector: 'remitter-chip',
    templateUrl: './remitter-chip.component.html',
    styleUrl: './remitter-chip.component.css',
})
export class RemitterChipComponent {
    @Input() icon: string = '';
    @Input() label: string = '';
    @Input() styleClass: any;
    @Input() severity: string = 'info';

    getStyleClass() {
        let newStyleClass: { [key: string]: boolean } = {
            'rem-bg-default': !this.severity || this.severity === 'primary',
            'rem-bg-light': this.severity === 'info',
        };

        if (this.styleClass) {
            newStyleClass[this.styleClass] = true;
        }

        return newStyleClass;
    }
}
